module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('order-line-charts'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市\n              ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.content.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.content, "bindingStoreList", $$v)
      },
      expression: "content.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right no-btn"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.storeTime,
      "option": _vm.dateoption,
      "limit": _vm.storeLimit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive ",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.storeStatusList), function(store) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_reject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_accept - store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_finish))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_normal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.order_count_day_group))])])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與份數比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-amount-compare"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與總額比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-compare"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單平均金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-average"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日會員數量")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "shopper-brief"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("今日24小時訂單數與金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "hour-brief"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("一日所有店家狀態列表"), _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(最多可選擇10間店家)")])]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("店名 (ID)")]), _vm._v(" "), _c('th', [_vm._v("已接受數量")]), _vm._v(" "), _c('th', [_vm._v("拒絕數量")]), _vm._v(" "), _c('th', [_vm._v("例外數量")]), _vm._v(" "), _c('th', [_vm._v("已完成數量")]), _vm._v(" "), _c('th', [_vm._v("一般單數量")]), _vm._v(" "), _c('th', [_vm._v("團購單數量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6545353a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BrandDashboard.vue
// module id = 2461
// module chunks = 1